module.exports = __webpack_public_path__ + "src/assets/img/btn01.2a61379c.png";